/* @flow */
import type { Attendance } from 'entities/ActivityRecipient';
import MessageComposer from './MessageComposer.jsx';
import React from 'react';
import { connect } from 'react-redux';
import Chat from 'entities/Chat';
import ActivityRecipient from 'entities/ActivityRecipient';
import ComposerEventRSVP from './ComposerEventRSVP.jsx';
import RSVPDialogContainer from 'payments/containers/RSVPDialogContainer.jsx';
import { mountModal } from 'lib/modal';

type Props = {
  chat: Chat,
  onMessageSend?: Function,
  className?: string,
  activityRecipient?: ?ActivityRecipient,
};

export class ConversationViewComposer extends React.Component {
  props: Props;

  focus() {
    if (this.refs.composer) {
      this.refs.composer.focus();
    }
  }

  onRSVPChange = (rsvp: ?Attendance) => {
    mountModal(
      <RSVPDialogContainer
        initialRSVP={rsvp}
        activityId={this.props.chat.getActivity().id}
      />
    , this);
  };

  render() {
    const { activityRecipient, className, chat, onMessageSend, ...rest } = this.props;
    if (chat.isActivityType() && activityRecipient && activityRecipient.getAttendance() === 'pending' && !chat.getActivity().isSender()) {
      return <ComposerEventRSVP onChange={this.onRSVPChange} />;
    }

    return (
      <MessageComposer
        {...rest}
        chat={chat}
        ref="composer"
        className={className}
        onMessageSend={onMessageSend}
      />
    );
  }
}

function mapStateToProps(state: Object, props: Object) {
  const activity = props.chat.getActivity();
  if (activity && activity.id) {
    const activityObj = state.activityRecipients.activities[activity.id] || {};
    return {
      activityRecipient: activityObj.currentUserRecipient,
    };
  }
  return {};
}

export default connect(
  mapStateToProps,
  undefined,
  undefined,
  { withRef: true, pure: false }
)(ConversationViewComposer);



// WEBPACK FOOTER //
// ./src/chat/components/ConversationViewComposer.jsx